export default "__VITE_ASSET__DBdCU$Ml__"